import React from 'react';

const BG_COLOR_CLASS = {
  red: 'bg-red-600',
  black: 'bg-black',
};
const DEFAULT_BG_CLASS = 'bg-white';

const ITEM_STYLE = {
  width: 'clamp(100px, 15vw, 200px)',
  height: 'clamp(60px, 9vw, 120px)',
};

const MarqueeRow = ({ brands, direction = 'left', speed = 10 }) => {
  const containerStyle = {
    '--marquee-duration': `${speed}s`,
    willChange: 'transform',
    backfaceVisibility: 'hidden',
  };

  return (
    <div className="relative overflow-hidden py-2 md:py-6">
      <div
        className={`flex gap-2 md:gap-6 whitespace-nowrap items-center marquee-${direction}`}
        style={containerStyle}
      >
        {/* 2x duplicate for perfect seamless loop */}
        {[...brands, ...brands].map((brand, idx) => {
          const bgColorClass = BG_COLOR_CLASS[brand.bgColor] || DEFAULT_BG_CLASS;
          return (
            <div
              key={`${brand.id}-${idx}`}
              className={`flex-shrink-0 flex items-center justify-center p-1.5 md:p-3 rounded-lg md:rounded-2xl hover:opacity-90 transition-all duration-300 group shadow-lg hover:shadow-xl overflow-hidden ${bgColorClass}`}
              style={ITEM_STYLE}
            >
              <img
                src={brand.src}
                alt={brand.name}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                style={brand.scale ? { transform: `scale(${brand.scale})` } : undefined}
                title={brand.name}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarqueeRow;
